import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Please log in.", -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Toast = _resolveComponent("Toast")!
  const _component_toolbar = _resolveComponent("toolbar")!
  const _component_navigation = _resolveComponent("navigation")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _createElementVNode("title", null, _toDisplayString(_ctx.appTitle) + " Admin | " + _toDisplayString(_ctx.$route.meta.title), 1)
    ])),
    _createVNode(_component_ConfirmDialog),
    _createVNode(_component_Toast),
    _createVNode(_component_toolbar),
    _createVNode(_Transition, { name: "nav" }, {
      default: _withCtx(() => [
        (_ctx.navOpen)
          ? (_openBlock(), _createBlock(_component_navigation, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("main", {
      class: _normalizeClass(["content-main", { 'nav-open': _ctx.navOpen }])
    }, [
      (_ctx.loggedIn)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
        : (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
          : _createCommentVNode("", true)
    ], 2),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}